exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  font-size: 16px;\n}\nhtml,\nbody,\n#app {\n  height: auto;\n}", ""]);

// exports
